export const GA4_EVENT = {
    search: 'search',
    startSearch: 'start_search',
    cancelSearch: 'cancel_search',
    displaySearchResult: 'display_search_result',
} as const;

export const GA4_METHOD = {
    viaHardSearch: 'via_hard_search',
    viaSearchSuggestions: 'via_search_suggestions',
    viaRecentSearches: 'via_recent_searches',
} as const;
